import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export type ConversationDto = {
    id: string;
    senderPhone: string;
    user: {
        id: string;
        firstName: string;
        lastName: string;
    } | null;
    createdAt: string;
    updatedAt: string;
};

export const GET_CONVERSATIONS_QUERY_KEY = (organizationId: string) => [
    'whatsapp-conversations',
    'list',
    organizationId,
];

type PaginatedConversations = {
    data: ConversationDto[];
    total: number;
    limit: number;
    offset: number;
};

export const useListConversations = (organizationId: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_CONVERSATIONS_QUERY_KEY(organizationId),
        queryFn: () =>
            client.fetchApi<PaginatedConversations, {}>({
                endpoint: `whatsapp-conversations/${organizationId}`,
                method: 'GET',
            }).then((res) => res.data),
        enabled: !!organizationId,
    });
};
